import script from "./BaseMenuModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseMenuModal.vue?vue&type=script&setup=true&lang=js"

import "./BaseMenuModal.vue?vue&type=style&index=0&id=b9d7c08a&lang=scss"

const __exports__ = script;

export default __exports__